export const game104PlayersD1 = [
  {
    display: "SirSam",
    id: "SirSam",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Asako",
    id: "Asako",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Hermit",
    id: "Hermit",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Digitaldude",
    id: "Digitaldude",
    img: "https://i.imgur.com/M8wKIIJ.png",
  },
  {
    display: "Demonspeed",
    id: "Demonspeed",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "GB",
    id: "GB",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "Gnut",
    id: "Gnut",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "Maryxxi",
    id: "Maryxxi",
    img: "https://i.gyazo.com/be8bd792cf946d89fb39051274d8d25b.png",
  },
  {
    display: "James Rye",
    id: "James",
    img: "https://i.gyazo.com/5188763f7e405ef37a9ae408145cb0a1.png",
  },
  {
    display: "Gajeel",
    id: "Gajeel",
    img: "https://i.gyazo.com/5188763f7e405ef37a9ae408145cb0a1.png",
  },
  {
    display: "Brandish",
    id: "Brandish",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Lady pompom",
    id: "Pom",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Shad",
    id: "Shad",
    img: "https://i.gyazo.com/1848689b7fce64316b00cfcb2dee6e48.png",
  },
  {
    display: "Tatsumaki",
    id: "Tatsumaki",
    img: "https://i.gyazo.com/1848689b7fce64316b00cfcb2dee6e48.png",
  },
];

export const game104PlayersD2 = [
  {
    display: "SirSam",
    id: "SirSam",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Asako",
    id: "Asako",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Hermit",
    id: "Hermit",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Demonspeed",
    id: "Demonspeed",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "GB",
    id: "GB",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "Gnut",
    id: "Gnut",
    img: "https://i.gyazo.com/cd054be6cc5f15c658d91881a4ecf5a3.png",
  },
  {
    display: "Maryxxi",
    id: "Maryxxi",
    img: "https://i.gyazo.com/be8bd792cf946d89fb39051274d8d25b.png",
  },
  {
    display: "James Rye",
    id: "James",
    img: "https://i.gyazo.com/5188763f7e405ef37a9ae408145cb0a1.png",
  },
  {
    display: "Brandish",
    id: "Brandish",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Lady pompom",
    id: "Pom",
    img: "https://i.gyazo.com/87ff4776a437e5d5301e1ee69e78c154.png",
  },
  {
    display: "Shad",
    id: "Shad",
    img: "https://i.gyazo.com/1848689b7fce64316b00cfcb2dee6e48.png",
  },
  {
    display: "Tatsumaki",
    id: "Tatsumaki",
    img: "https://i.gyazo.com/1848689b7fce64316b00cfcb2dee6e48.png",
  },
];
